import { FC } from 'react';
import styled, { css } from 'styled-components';
import { Box, Button, ButtonAppearance, ButtonProps, ButtonSize } from '@bechtel/gds';

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}

export interface BoxStyledProps {
  type?: string;
}

export const TimesheetTabStyled = styled(Box).attrs({ pt: { sm: '600' }, pl: { sm: '400' } })`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
`;

export const BoxStyled = styled(Box).attrs({
  mr: { sm: '300' },
})<BoxStyledProps>`
  ${({ theme, type }) =>
    css`
      background-color: ${theme.colors.blue[500]};
      width: ${theme.spacings['500']};
      height: ${theme.spacings['500']};
      border-radius: ${theme.spacings['100']};
      ${type === 'claimed' &&
      css`
        background-color: ${theme.colors.orange[500]};
      `};
      ${type === 'unplanned' &&
      css`
        background-color: ${theme.colors.grey[500]};
      `};
    `}
`;

export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  width: auto;
  min-width: 110px;
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;
